import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Button } from 'react-bootstrap';
import './poststormsurvey.css';
import { GetSurveyDetailsbyInstanceIdAsync, GetSurveyResponseAsync, SaveServeyResponse } from '../../../services/surveyService/SurveyService';
import { useAuth } from '../../../firebase/AuthProvider';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../loader/Loader';
import backarrowbtn from '../../../assets/images/backarrowbtn.svg'
import { EmergencyEventDto } from '../../../interfaces/survey/SurveyDtos';

const initialSurveyData = {
    electricity: "",
    generatorPower: "",
    water: "",
    drinkingWater: "",
    evacuatedAfterStorm: "",
    homeDamage: [] as string[],
    needToEvacuateNow: "",
    needEvacuationAssistance: "",
    hasInsurance: "",
    appliedFEMA: "",
    femaStatus: [] as string[],
    receivingInHomeServices: "",
    dswArriving: "",
    assistanceWho: [] as string[],
    resourcesNeeded: "",
    assistanceAvailable: "",
    changeDetails: ""
};

const Poststormsurvey: React.FC = () => {
    const { currentUser } = useAuth();
    const { participantId, instanceId } = useParams();
    const [surveyData, setSurveyData] = useState<typeof initialSurveyData>(initialSurveyData);
    const [authToken, setAuthToken] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);
    const [isAlreadyFilled, setIsAllreadyFilled] = useState<boolean>(false);
    const [validated, setValidated] = useState(false);
    const navigate = useNavigate();
    const [surveyDetails, setSurveyDetails] = useState<EmergencyEventDto>();

    useEffect(() => {
        currentUser?.getIdToken().then((token) => {
            if (token) {
                setAuthToken(token);
                if (instanceId) {
                    GetSurveyResponse(token, instanceId);
                    GetSurveyDetailsByInstanceId(token, instanceId);
                }
            }
        })
    }, []);


      const GetSurveyDetailsByInstanceId = ( token : string, instance_Id : string) =>{
        GetSurveyDetailsbyInstanceIdAsync(token, instance_Id).then((res)=>{
            if(res.success){
                setSurveyDetails(res.data);
            }else{
                toast.error(res.message);
            }
        }).catch((err)=>{
                toast.error(err.message);
        })
    }

    const GetSurveyResponse = (token: string, instance_Id: string) => {
        setLoading(true);
        GetSurveyResponseAsync(token, instance_Id).then((res) => {
            if (res.success) {
                const surveyData = JSON.parse(res.data.responseData);
                setSurveyData(surveyData)
                setIsAllreadyFilled(true);
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    // Handlers for radio fields
    const handleRadio = (key: keyof typeof initialSurveyData, value: string) => {
        setSurveyData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    // Handler for checkbox arrays
    const handleCheckboxArray = (key: keyof typeof initialSurveyData, value: string, checked: boolean) => {
        setSurveyData(prev => ({
            ...prev,
            [key]: checked
                ? [...(prev[key] as string[]), value]
                : (prev[key] as string[]).filter(v => v !== value)
        }));
    };

    // Handler for text fields
    const handleText = (key: keyof typeof initialSurveyData, value: string) => {
        setSurveyData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    // Validation helpers
    const validateSurvey = () => {
        if (!surveyData.electricity) return false;
        if (!surveyData.generatorPower) return false;
        if (!surveyData.water) return false;
        if (!surveyData.drinkingWater) return false;
        if (!surveyData.evacuatedAfterStorm) return false;
        if (surveyData.homeDamage.length === 0) return false;
        if (!surveyData.needToEvacuateNow) return false;
        if (!surveyData.needEvacuationAssistance) return false;
        if (!surveyData.hasInsurance) return false;
        if (!surveyData.appliedFEMA) return false;
        if (surveyData.femaStatus.length === 0) return false;
        if (!surveyData.receivingInHomeServices) return false;
        if (!surveyData.dswArriving) return false;
        if (surveyData.assistanceWho.length === 0) return false;
        if (!surveyData.resourcesNeeded) return false;
        if (!surveyData.assistanceAvailable) return false;
        if (!surveyData.changeDetails) return false;
        return true;
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setValidated(true);
        if (!authToken || !instanceId) return;
        if (!validateSurvey()) {
            toast.error("Please fill all required fields.");
            return;
        }
        setLoading(true);
        SaveServeyResponse(authToken, surveyData, instanceId).then((res) => {
            if (res.success) {
                toast.success(res.message);
                navigate(`/surveys/participant/${participantId}`)
            } else {
                toast.error(res.message);
            }
        }).catch((err) => {
            toast.error(err.message);
        }).finally(() => {
            setLoading(false);
        })
    };

    return (
        <>
            {loading && <Loader />}
            <div className="prestorm_survey_conatiner">
                <Form onSubmit={handleSubmit}>
                    <div className="common_card">
                        <div className="top border_tittle mby_16">
                            <div className="top_bar_tittle">
                                <h2><Link to={`/surveys/participant/${participantId}`}><img src={backarrowbtn} alt="" /></Link> {surveyDetails?.emergencyType}</h2>
                            </div>
                            <div>
                                <p>EmergencyDetail : {surveyDetails?.emergencyDetail}</p>
                            </div>
                        </div>
                        <div className="evacuation_plans_head mby_16">
                            <h3>Do you currently have</h3>
                        </div>
                        <Form.Group className="step_form_grp" controlId="Q1">
                            <Form.Label className='required-label'>1. Electricity?</Form.Label>
                            <div className="check_list_yes_no">
                                <Form.Check
                                    type="radio"
                                    id="Q1Yes"
                                    name="Q1"
                                    label="Yes"
                                    className='check_with_label_two'
                                    checked={surveyData.electricity === "Yes"}
                                    onChange={() => handleRadio("electricity", "Yes")}
                                    disabled={isAlreadyFilled}
                                />
                                <Form.Check
                                    type="radio"
                                    id="Q1No"
                                    name="Q1"
                                    label="No"
                                    className='check_with_label_two'
                                    checked={surveyData.electricity === "No"}
                                    onChange={() => handleRadio("electricity", "No")}
                                    disabled={isAlreadyFilled}
                                />
                            </div>
                        </Form.Group>
                    </div>
                    <div className="common_card">
                        <Form.Group className="step_form_grp" controlId="Q2">
                            <Form.Label className='required-label'>2. Generator Power?</Form.Label>
                            <div className="check_list_yes_no">
                                <Form.Check
                                    type="radio"
                                    id="Q2Yes"
                                    name="Q2"
                                    label="Yes"
                                    className='check_with_label_two'
                                    checked={surveyData.generatorPower === "Yes"}
                                    onChange={() => handleRadio("generatorPower", "Yes")}
                                    disabled={isAlreadyFilled}
                                />
                                <Form.Check
                                    type="radio"
                                    id="Q2No"
                                    name="Q2"
                                    label="No"
                                    className='check_with_label_two'
                                    checked={surveyData.generatorPower === "No"}
                                    onChange={() => handleRadio("generatorPower", "No")}
                                    disabled={isAlreadyFilled}
                                />
                            </div>
                        </Form.Group>
                    </div>
                    <div className="common_card">
                        <Form.Group className="step_form_grp" controlId="Q3">
                            <Form.Label className='required-label'>3. Water?</Form.Label>
                            <div className="check_list_yes_no">
                                <Form.Check
                                    type="radio"
                                    id="Q3Yes"
                                    name="Q3"
                                    label="Yes"
                                    className='check_with_label_two'
                                    checked={surveyData.water === "Yes"}
                                    onChange={() => handleRadio("water", "Yes")}
                                    disabled={isAlreadyFilled}
                                />
                                <Form.Check
                                    type="radio"
                                    id="Q3No"
                                    name="Q3"
                                    label="No"
                                    className='check_with_label_two'
                                    checked={surveyData.water === "No"}
                                    onChange={() => handleRadio("water", "No")}
                                    disabled={isAlreadyFilled}
                                />
                            </div>
                        </Form.Group>
                    </div>
                    <div className="common_card">
                        <Form.Group className="step_form_grp" controlId="Q4">
                            <Form.Label className='required-label'>4. Drinking Water?</Form.Label>
                            <div className="check_list_yes_no">
                                <Form.Check
                                    type="radio"
                                    id="Q4Yes"
                                    name="Q4"
                                    label="Yes"
                                    className='check_with_label_two'
                                    checked={surveyData.drinkingWater === "Yes"}
                                    onChange={() => handleRadio("drinkingWater", "Yes")}
                                    disabled={isAlreadyFilled}
                                />
                                <Form.Check
                                    type="radio"
                                    id="Q4No"
                                    name="Q4"
                                    label="No"
                                    className='check_with_label_two'
                                    checked={surveyData.drinkingWater === "No"}
                                    onChange={() => handleRadio("drinkingWater", "No")}
                                    disabled={isAlreadyFilled}
                                />
                            </div>
                        </Form.Group>
                    </div>
                    <div className="common_card">
                        <Form.Group className="step_form_grp" controlId="Q5">
                            <Form.Label className='required-label'>5. Did you evacuate after the storm hit?</Form.Label>
                            <div className="check_list_yes_no">
                                <Form.Check
                                    type="radio"
                                    id="Q5Yes"
                                    name="Q5"
                                    label="Yes"
                                    className='check_with_label_two'
                                    checked={surveyData.evacuatedAfterStorm === "Yes"}
                                    onChange={() => handleRadio("evacuatedAfterStorm", "Yes")}
                                    disabled={isAlreadyFilled}
                                />
                                <Form.Check
                                    type="radio"
                                    id="Q5No"
                                    name="Q5"
                                    label="No"
                                    className='check_with_label_two'
                                    checked={surveyData.evacuatedAfterStorm === "No"}
                                    onChange={() => handleRadio("evacuatedAfterStorm", "No")}
                                    disabled={isAlreadyFilled}
                                />
                            </div>
                        </Form.Group>
                    </div>
                    <div className="common_card">
                        <div className="top border_tittle">
                            <div className="top_bar_tittle">
                                <h2>Housing Conditions</h2>
                            </div>
                        </div>
                        <Form.Group className="step_form_grp mby_t_16" controlId="HC">
                            <Form.Label className='required-label'>Type of damage to home</Form.Label>
                            <div className="check_list_flx flex-column">
                                {["None", "Yard Debris", "Outside Damage", "Inside Damage", "Flooding", "Uninhabitable"].map(damage => (
                                    <Form.Check
                                        key={damage}
                                        type="checkbox"
                                        id={`HC-${damage}`}
                                        name="homeDamage"
                                        label={damage}
                                        className='check_with_label_two'
                                        checked={surveyData.homeDamage.includes(damage)}
                                        onChange={e => handleCheckboxArray("homeDamage", damage, e.target.checked)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                    </div>
                    <div className="common_card">
                        <Form.Group className="step_form_grp" controlId="HCQ1">
                            <Form.Label className='required-label'>1. Do you need to evacuate now?</Form.Label>
                            <div className="check_list_yes_no">
                                <Form.Check
                                    type="radio"
                                    id="HCQ1Yes"
                                    name="HCQ1"
                                    label="Yes"
                                    className='check_with_label_two'
                                    checked={surveyData.needToEvacuateNow === "Yes"}
                                    onChange={() => handleRadio("needToEvacuateNow", "Yes")}
                                    disabled={isAlreadyFilled}
                                />
                                <Form.Check
                                    type="radio"
                                    id="HCQ1No"
                                    name="HCQ1"
                                    label="No"
                                    className='check_with_label_two'
                                    checked={surveyData.needToEvacuateNow === "No"}
                                    onChange={() => handleRadio("needToEvacuateNow", "No")}
                                    disabled={isAlreadyFilled}
                                />
                            </div>
                        </Form.Group>
                    </div>
                    <div className="common_card">
                        <Form.Group className="step_form_grp" controlId="HCQ2">
                            <Form.Label className='required-label'>2. Need assistance evacuating?</Form.Label>
                            <div className="check_list_yes_no">
                                <Form.Check
                                    type="radio"
                                    id="HCQ2Yes"
                                    name="HCQ2"
                                    label="Yes"
                                    className='check_with_label_two'
                                    checked={surveyData.needEvacuationAssistance === "Yes"}
                                    onChange={() => handleRadio("needEvacuationAssistance", "Yes")}
                                    disabled={isAlreadyFilled}
                                />
                                <Form.Check
                                    type="radio"
                                    id="HCQ2No"
                                    name="HCQ2"
                                    label="No"
                                    className='check_with_label_two'
                                    checked={surveyData.needEvacuationAssistance === "No"}
                                    onChange={() => handleRadio("needEvacuationAssistance", "No")}
                                    disabled={isAlreadyFilled}
                                />
                            </div>
                        </Form.Group>
                    </div>
                    <div className="common_card">
                        <Form.Group className="step_form_grp" controlId="HCQ3">
                            <Form.Label className='required-label'>3. Do you have Homeowner/Renter Insurance?</Form.Label>
                            <div className="check_list_yes_no">
                                <Form.Check
                                    type="radio"
                                    id="HCQ3Yes"
                                    name="HCQ3"
                                    label="Yes"
                                    className='check_with_label_two'
                                    checked={surveyData.hasInsurance === "Yes"}
                                    onChange={() => handleRadio("hasInsurance", "Yes")}
                                    disabled={isAlreadyFilled}
                                />
                                <Form.Check
                                    type="radio"
                                    id="HCQ3No"
                                    name="HCQ3"
                                    label="No"
                                    className='check_with_label_two'
                                    checked={surveyData.hasInsurance === "No"}
                                    onChange={() => handleRadio("hasInsurance", "No")}
                                    disabled={isAlreadyFilled}
                                />
                            </div>
                        </Form.Group>
                    </div>
                    <div className="common_card">
                        <Form.Group className="step_form_grp" controlId="FEMA">
                            <Form.Label className='required-label'>Applied for FEMA?</Form.Label>
                            <div className="check_list_yes_no">
                                <Form.Check
                                    type="radio"
                                    id="FEMAYes"
                                    name="FEMA"
                                    label="Yes"
                                    className='check_with_label_two'
                                    checked={surveyData.appliedFEMA === "Yes"}
                                    onChange={() => handleRadio("appliedFEMA", "Yes")}
                                    disabled={isAlreadyFilled}
                                />
                                <Form.Check
                                    type="radio"
                                    id="FEMANo"
                                    name="FEMA"
                                    label="No"
                                    className='check_with_label_two'
                                    checked={surveyData.appliedFEMA === "No"}
                                    onChange={() => handleRadio("appliedFEMA", "No")}
                                    disabled={isAlreadyFilled}
                                />
                            </div>
                        </Form.Group>
                        <Form.Group className="step_form_grp mby_t_16" controlId="damage">
                            <Form.Label className='required-label'>Type of damage to home</Form.Label>
                            <div className="check_list_flx flex-column">
                                {["Decision Pending", "Approved", "Denied"].map(status => (
                                    <Form.Check
                                        key={status}
                                        type="checkbox"
                                        id={`femaStatus-${status}`}
                                        name="femaStatus"
                                        label={status}
                                        className='check_with_label_two'
                                        checked={surveyData.femaStatus.includes(status)}
                                        onChange={e => handleCheckboxArray("femaStatus", status, e.target.checked)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                    </div>
                    <div className="common_card">
                        <div className="top border_tittle mby_16">
                            <div className="top_bar_tittle">
                                <h2>Living Situation</h2>
                            </div>
                        </div>
                        <Form.Group className="step_form_grp" controlId="LSQ1">
                            <Form.Label className='required-label'>1. Receiving in-home services?</Form.Label>
                            <div className="check_list_yes_no">
                                <Form.Check
                                    type="radio"
                                    id="LSQ1Yes"
                                    name="LSQ1"
                                    label="Yes"
                                    className='check_with_label_two'
                                    checked={surveyData.receivingInHomeServices === "Yes"}
                                    onChange={() => handleRadio("receivingInHomeServices", "Yes")}
                                    disabled={isAlreadyFilled}
                                />
                                <Form.Check
                                    type="radio"
                                    id="LSQ1No"
                                    name="LSQ1"
                                    label="No"
                                    className='check_with_label_two'
                                    checked={surveyData.receivingInHomeServices === "No"}
                                    onChange={() => handleRadio("receivingInHomeServices", "No")}
                                    disabled={isAlreadyFilled}
                                />
                            </div>
                        </Form.Group>
                    </div>
                    <div className="common_card">
                        <Form.Group className="step_form_grp" controlId="LSQ3">
                            <Form.Label className='required-label'>2. DSW arriving as scheduled?</Form.Label>
                            <div className="check_list_yes_no">
                                <Form.Check
                                    type="radio"
                                    id="LSQ3Yes"
                                    name="LSQ3"
                                    label="Yes"
                                    className='check_with_label_two'
                                    checked={surveyData.dswArriving === "Yes"}
                                    onChange={() => handleRadio("dswArriving", "Yes")}
                                    disabled={isAlreadyFilled}
                                />
                                <Form.Check
                                    type="radio"
                                    id="LSQ3No"
                                    name="LSQ3"
                                    label="No"
                                    className='check_with_label_two'
                                    checked={surveyData.dswArriving === "No"}
                                    onChange={() => handleRadio("dswArriving", "No")}
                                    disabled={isAlreadyFilled}
                                />
                            </div>
                        </Form.Group>
                    </div>
                    <div className="common_card">
                        <Form.Group className="step_form_grp mby_t_16" controlId="assistanceWho">
                            <Form.Label className='required-label'>Who is assisting you?</Form.Label>
                            <div className="check_list_flx flex-column">
                                {["Family", "Friend", "No one without difficulty", "No one with difficulty"].map(who => (
                                    <Form.Check
                                        key={who}
                                        type="checkbox"
                                        id={`assistanceWho-${who}`}
                                        name="assistanceWho"
                                        label={who}
                                        className='check_with_label_two'
                                        checked={surveyData.assistanceWho.includes(who)}
                                        onChange={e => handleCheckboxArray("assistanceWho", who, e.target.checked)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                    </div>
                    <div className="common_card">
                        <div className="top border_tittle mby_16">
                            <div className="top_bar_tittle">
                                <h2>Needs and Resources</h2>
                            </div>
                        </div>
                        <Form.Group className="custom_input_flled" controlId="resourcesNeeded">
                            <Form.Label className='required-label'>Resources Needed?</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Yard help, FEMA help, Food, etc"
                                value={surveyData.resourcesNeeded}
                                onChange={e => handleText("resourcesNeeded", e.target.value)}
                                disabled={isAlreadyFilled}
                            />
                        </Form.Group>
                        <Form.Group className="step_form_grp mby_16" controlId="assistanceAvailable">
                            <Form.Label className='required-label'>Who is assisting you?</Form.Label>
                            <div className="check_list_yes_no">
                                <Form.Check
                                    type="radio"
                                    id="AUYes"
                                    name="assistanceAvailable"
                                    label="Yes"
                                    className='check_with_label_two'
                                    checked={surveyData.assistanceAvailable === "Yes"}
                                    onChange={() => handleRadio("assistanceAvailable", "Yes")}
                                    disabled={isAlreadyFilled}
                                />
                                <Form.Check
                                    type="radio"
                                    id="AUNo"
                                    name="assistanceAvailable"
                                    label="No"
                                    className='check_with_label_two'
                                    checked={surveyData.assistanceAvailable === "No"}
                                    onChange={() => handleRadio("assistanceAvailable", "No")}
                                    disabled={isAlreadyFilled}
                                />
                            </div>
                        </Form.Group>
                        <Form.Group className="custom_input_flled mb-0" controlId="changeDetails">
                            <Form.Label className='required-label'>Change details?</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Inaccessible, not safe, no home care, etc."
                                value={surveyData.changeDetails}
                                onChange={e => handleText("changeDetails", e.target.value)}
                                disabled={isAlreadyFilled}
                            />
                        </Form.Group>
                        <div className='mby_t_24'>
                            <Button variant='primary' className='w-100' type="submit" disabled={isAlreadyFilled}>Submit</Button>
                        </div>
                    </div>
                </Form>
            </div>
        </>
    );
};

export default Poststormsurvey;